import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'claims-generic-modal-dialog',
    templateUrl: './generic-modal-dialog.component.html',
    styleUrls: ['./generic-modal-dialog.component.scss']
})
export class GenericModalDialogComponent {
    @Input() public isOpen = true;
    @Input() public showCloseIcon = true;
    @Input() public showOptionalFileNameInput = false;
    @Input() public modalTitleIconCss = '';
    @Input() public modalTitle = '';
    @Input() public modalTitleDescription = '';
    @Input() public modalNotificationIconCss = '';
    @Input() public modalNotificationIconWithText = '';
    @Input() public modalNotificationIconMessageHeading = '';
    @Input() public modalNotificationIconMessageList: Array<string> = [];
    @Input() public modalExportFileName = '';
    public modalExportFileNameInvalid = false;
    @Input() public modalCancelButtonText = '';
    @Input() public modalSubmitButtonText = '';

    @Output() public eventSubmitNotify = new EventEmitter<any>();
    @Output() public eventCancelNotify = new EventEmitter<any>();

    public onSubmitNotifyClick(): void {
        if (this.showOptionalFileNameInput) {
            const outputdata = { isGenericModalDialogVisible: false, exportFileName: this.modalExportFileName };
            this.eventSubmitNotify.emit(outputdata);
        }
    }
    public onCancelNotify(): void {
        const outputdata = { isGenericModalDialogVisible: false };
        this.eventCancelNotify.emit(outputdata);
    }

    public validateFileName(): void {
        if (this.modalExportFileName && this.modalExportFileName.trim() !== '') {
            const fileHasExtension =
                this.modalExportFileName.includes('.') &&
                this.modalExportFileName.substring(this.modalExportFileName.lastIndexOf('.') + 1) !== '';
            if (fileHasExtension) {
                this.modalExportFileNameInvalid = !/^[\w _.@()-]+.(xlsx)$/i.test(this.modalExportFileName);
            } else {
                this.modalExportFileNameInvalid = !/^[\w _.@()-]+$/i.test(this.modalExportFileName);
            }
        } else {
            this.modalExportFileNameInvalid = true;
        }
    }
}
